// extracted by mini-css-extract-plugin
module.exports = {"ItemHomeBox":"styles_ItemHomeBox__1VW3J"};